/* Custom "Notify me when available" (back-in-stock) modal.
   Replaces Klaviyo's DEPRECATED onsite back-in-stock (klaviyo.enable("backinstock", …)), which stopped
   binding the .klaviyo-bis-trigger button — clicking it fired no handler and no request, so nothing
   opened. This opens our own modal and submits directly to Klaviyo's CURRENT client-side back-in-stock
   API, which creates the exact same "back-in-stock subscription" object the merchant's Klaviyo
   Back-in-Stock flow already triggers on — so flows + emails work unchanged.

   The trigger button (<a class="klaviyo-bis-trigger llm-klaviyo-bis-trigger">) and its show/hide on
   sold-out variants are unchanged (snippets/llm-product-cart-strip.liquid + assets/llm-klaviyo-stock-sync.js).
   We only take over the click + modal + submit. */
(function () {
  var KLAVIYO_COMPANY_ID = 'HBc93p'; // public site key (safe client-side; same one theme.liquid uses)
  var API = 'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + KLAVIYO_COMPANY_ID;
  var REVISION = '2024-10-15';
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  var currentVariantId = null;
  var currentVariantTitle = null;
  var overlay, emailInput, msgEl, submitBtn, headingEl, variantEl, formEl;

  // The selected variant = the main product form's id input (the theme keeps it in sync with the
  // variant picker). Fall back to any product-form id input, the on:variant:change value, then the URL.
  function readCurrentVariant() {
    var input = document.querySelector('.js-product-form-main [name="id"]')
      || document.querySelector('product-form [name="id"]')
      || document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (input && input.value) { currentVariantId = input.value; return; }
    var p = new URLSearchParams(location.search).get('variant');
    if (p) currentVariantId = p;
  }
  document.addEventListener('on:variant:change', function (evt) {
    var v = evt.detail && evt.detail.variant;
    if (v && v.id != null) currentVariantId = String(v.id);
    if (v && v.title) currentVariantTitle = v.title;
  });

  // The selected variant's display name, shown under the product name in the modal. Prefer the
  // option-selector's own visible label (matches exactly what the page shows: e.g. 'MD (29" to 43") |
  // Pack of 15'), then the change-event title. Blank for single-variant products ("Default Title").
  function getSelectedVariantName() {
    var el = document.querySelector('.llm-option-trigger-label__value');
    var name = (el && el.textContent.trim()) || currentVariantTitle || '';
    if (!name || name === 'Default Title') return '';
    return name;
  }

  function buildModal() {
    overlay = document.createElement('div');
    overlay.className = 'llm-bis-overlay';
    overlay.innerHTML =
      '<div class="llm-bis-modal" role="dialog" aria-modal="true" aria-labelledby="llm-bis-heading">' +
        '<button type="button" class="llm-bis-close" aria-label="Close">×</button>' +
        '<h2 class="llm-bis-heading" id="llm-bis-heading">Notify me when available</h2>' +
        '<p class="llm-bis-variant"></p>' +
        '<p class="llm-bis-body">Register to receive a notification when this item comes back in stock.</p>' +
        '<form class="llm-bis-form" novalidate>' +
          '<input type="email" class="llm-bis-email" placeholder="Email" aria-label="Email" autocomplete="email" required>' +
          '<button type="submit" class="llm-bis-submit btn btn--primary">Notify me when available</button>' +
        '</form>' +
        '<div class="llm-bis-msg" role="status" aria-live="polite"></div>' +
      '</div>';
    document.body.appendChild(overlay);
    emailInput = overlay.querySelector('.llm-bis-email');
    msgEl = overlay.querySelector('.llm-bis-msg');
    submitBtn = overlay.querySelector('.llm-bis-submit');
    headingEl = overlay.querySelector('.llm-bis-heading');
    variantEl = overlay.querySelector('.llm-bis-variant');
    formEl = overlay.querySelector('.llm-bis-form');
    overlay.querySelector('.llm-bis-close').addEventListener('click', close);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
    formEl.addEventListener('submit', onSubmit);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) close();
    });
  }

  function open() {
    if (!overlay) buildModal();
    msgEl.textContent = ''; msgEl.className = 'llm-bis-msg';
    emailInput.value = ''; emailInput.disabled = false;
    submitBtn.disabled = false; submitBtn.textContent = 'Notify me when available';
    formEl.hidden = false;
    var titleEl = document.querySelector('.product-title, .product-info__title, .main-product h1, h1.product-title');
    headingEl.textContent = titleEl && titleEl.textContent.trim() ? titleEl.textContent.trim() : 'Notify me when available';
    var vname = getSelectedVariantName();
    variantEl.textContent = vname;
    variantEl.style.display = vname ? '' : 'none';
    overlay.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    /* Not on touch: the keyboard opens with the focus and covers the modal, including the product
       name that tells the customer WHICH item they are asking about (owner 2026-09-04, same fix as
       llm-hero-finder.js). They tap the field when they are ready. */
    if (!(window.matchMedia && window.matchMedia('(pointer: coarse)').matches)) {
      setTimeout(function () { try { emailInput.focus(); } catch (e) {} }, 50);
    }
  }

  function close() {
    if (!overlay) return;
    overlay.classList.remove('is-open');
    document.documentElement.style.overflow = '';
  }

  function showMsg(text, type) { msgEl.textContent = text; msgEl.className = 'llm-bis-msg llm-bis-msg--' + type; }

  function onSubmit(e) {
    e.preventDefault();
    var email = (emailInput.value || '').trim();
    if (!EMAIL_RE.test(email)) { showMsg('Please enter a valid email address.', 'error'); return; }
    readCurrentVariant();
    if (!currentVariantId) { showMsg('Something went wrong — please refresh and try again.', 'error'); return; }

    submitBtn.disabled = true; submitBtn.textContent = 'Submitting…'; showMsg('', '');
    var body = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          channels: ['EMAIL'],
          profile: { data: { type: 'profile', attributes: { email: email } } }
        },
        relationships: {
          variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + currentVariantId } }
        }
      }
    };
    fetch(API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: REVISION },
      body: JSON.stringify(body)
    }).then(function (res) {
      if (res.status === 202 || res.ok) {
        formEl.hidden = true;
        showMsg("You're in! We'll email you when it's back in stock.", 'success');
      } else {
        throw new Error('status ' + res.status);
      }
    }).catch(function () {
      submitBtn.disabled = false; submitBtn.textContent = 'Notify me when available';
      showMsg('Sorry, something went wrong. Please try again.', 'error');
    });
  }

  // Delegated so it works no matter when the trigger is shown / re-rendered.
  document.addEventListener('click', function (e) {
    var trig = e.target.closest('.klaviyo-bis-trigger, .llm-klaviyo-bis-trigger');
    if (!trig) return;
    e.preventDefault();
    readCurrentVariant();
    open();
  });

  readCurrentVariant();
})();
